import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from 'react-redux';
import providers from '../../../../images/provider_h.png';
import administrators from '../../../../images/admin_h.png';
import careHistory from '../../../../images/history_h.png';
import benefits from '../../../../images/benefits_h.png';
import affiliate from '../../../../images/affiliate_h.png';
import plans from '../../../../images/plans_h.png';
import actions from '../../../../redux/actions';
import '../Home.scss';
import {Redirect} from 'react-router-dom';
import LogRocket from 'logrocket';

const currentUrl = window.location.href;
if (currentUrl.includes(process.env.REACT_APP_PROD_URL)) {
    LogRocket.init(process.env.REACT_APP_LOG_ROCKET_ID);
}

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */

const providerUserModules = [
    // {
    //     name: 'Historial atenciones',
    //     route: '/attentionsList',
    //     img: careHistory,
    //   },
    // {
    //     name: 'Atenciones',
    //     route: '/newMedicalService',
    //     img: benefits,
    // },
    // {
    //     name: 'Planes',
    //     route: '/plans/list',
    //     img: plans,
    // },
    {
        name: 'Nueva atención',
        route: '/createAttention',
        img: benefits,
    },
];

const providerUserModulesFf = [
    {
        name: 'Nueva atención',
        route: '/createAttention',
        img: benefits,
    },
    {
        name: 'Historial atenciones',
        route: '/v1/attentionsList',
        img: careHistory,
    },
    {
        name: 'Planes',
        route: '/v1/plans/list',
        img: plans,
    },
    {
        name: 'Afiliados',
        route: '/affiliates',
        img: affiliate,
    },
];

const providerAdminModules = [
    //  {
    //     name: 'Usuarios de Prestadores',
    //     route: '/provider/list',
    //     img: providers,
    //   },
    ...providerUserModules,
];

const providerAdminModulesFf = [
    //  {
    //     name: 'Usuarios de Prestadores',
    //     route: '/provider/list',
    //     img: providers,
    //   },
    ...providerUserModulesFf,
];

const adminModules = [
    {
        name: 'Nueva atención',
        route: '/createAttention',
        img: benefits,
    },
    {
        name: 'Administradores',
        route: '/v1/admin/list',
        img: administrators,
    },
    {
        name: 'Historial atenciones',
        route: '/v1/attentionsList',
        // route: '/home',
        img: careHistory,
    },
    {
        name: 'Usuarios de Prestadores',
        route: '/providerUsers',
        img: providers,
    },
    {
        name: 'Afiliados',
        route: '/v1/affiliates',
        img: affiliate,
    },
    {
        name: 'Planes',
        route: '/v1/plans/list',
        img: plans,
    },
];

const providerUserViewerModules = [
    {
        name: 'Afiliados',
        route: '/affiliates',
        img: affiliate,
    },
];

const developerModules = [
    {
        name: 'API',
        route: '/api',
        img: benefits,
    },
];

const Home = ({name, userInfo, switchOfUser, selectSelf, showSidebar, featureFlag}) => {
    const [modules, setModules] = useState([]);
    const dispatch = useDispatch();

    useEffect(()=> {
        if (showSidebar && window.innerWidth <= 700) {
            dispatch(actions.common.toggleSideBar());
        }
    }, []);

    useEffect(() => {
        if (userInfo) {
            selectSelf();
        }
        switch (userInfo.role.name) {
            case 'ADMIN':
                setModules(adminModules);
                break;
            case 'PROVIDER_ADMIN':
                if (featureFlag) {
                    setModules(providerAdminModulesFf);
                } else {
                    setModules(providerAdminModules);
                }
                break;
            case 'PROVIDER_USER':
                if (featureFlag) {
                    setModules(providerUserModulesFf);
                } else {
                    setModules(providerUserModules);
                }
                break;
            case 'DEVELOPER':
                setModules(developerModules);
                break;
            default:
                setModules(providerUserViewerModules);
                break;
        }
        // eslint-disable-next-line
    }, [name]);

    useEffect(() => {
        switch (userInfo.role.name) {
            case 'ADMIN':
                setModules(adminModules);
                break;
            case 'PROVIDER_ADMIN':
                if (featureFlag) {
                    setModules(providerAdminModulesFf);
                } else {
                    setModules(providerAdminModules);
                }
                break;
            case 'PROVIDER_USER':
                if (featureFlag) {
                    setModules(providerUserModulesFf);
                } else {
                    setModules(providerUserModules);
                }
                break;
            case 'DEVELOPER':
                setModules(developerModules);
                break;
            default:
                setModules(providerUserViewerModules);
                break;
        }
        // eslint-disable-next-line
    }, [featureFlag]);

    return (
        <div>
            {modules[0]?.route && <Redirect to={modules[0].route}/>}
        </div>
    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    userInfo: state.login.userInfo,
    showSidebar: state.common.showSidebar,
    featureFlag: state.home.setSelfState.featureFlag,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    selectSelf: () => dispatch(actions.home.selectSelf()),
});

Home.propTypes = {};


export default connect(mapStateToProps, mapDispatchToProps)(Home);
